var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDarkIcon = function SvgDarkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 50 58",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "079---Brightness",
    fill: "rgb(0,0,0)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m14.8 19.67c-3.341 2.995-6.8 6.093-6.8 13.33 0 9.3888407 7.6111593 17 17 17s17-7.6111593 17-17c0-7.237-3.459-10.335-6.8-13.33-2.442-2.187-4.76-4.262-5.141-7.67h-2.059v10c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-10h-2v10c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1v-10h-2.055c-.381 3.408-2.699 5.483-5.145 7.67zm11.2 6.33c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1zm-4 0c0-.5522847.4477153-1 1-1s1 .4477153 1 1v1c0 .5522847-.4477153 1-1 1s-1-.4477153-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20 5v5h10v-2h-7c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h7v-1c0-.55228475-.4477153-1-1-1h-8c-.5522847 0-1 .44771525-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 0h-4c-.5522847 0-1 .44771525-1 1v1h6v-1c0-.55228475-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m26 57v-2c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2c0 .5522847.4477153 1 1 1s1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 54.784c.3570824-.000366.6868739-.1911096.8652566-.5004437s.1782849-.6903138-.0002566-.9995563l-1-1.731c-.1773616-.3119508-.5082732-.5049532-.8671183-.5057421s-.6906021.1907567-.8693336.5019247c-.1787314.3111679-.1770325.694247.0044519 1.0038174l1 1.731c.1788068.3097028.5093863.5003484.867.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46.65 45.5c.2761293-.4782803.1122682-1.0898496-.366-1.366l-1.731-1c-.3095704-.1814844-.6926495-.1831833-1.0038174-.0044519-.311168.1787315-.5027136.5104885-.5019247.8693336s.1937913.6897567.5057421.8671183l1.731 1c.4782803.2761293 1.0898496.1122682 1.366-.366z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 34c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m45.284 20.134-1.731 1c-.3119508.1773616-.5049532.5082732-.5057421.8671183s.1907567.6906021.5019247.8693336c.3111679.1787314.694247.1770325 1.0038174-.0044519l1.731-1c.4742136-.2780058.6351286-.886647.3602745-1.3626943-.274854-.4760473-.8824145-.640996-1.3602745-.3693057z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m3.35 20.5c-.27612934.4782803-.11226816 1.0898496.366 1.366l1.731 1c.47785996.2716903 1.08542045.1067416 1.36027453-.3693057s.11393908-1.0846885-.36027453-1.3626943l-1.731-1c-.47828031-.2761293-1.08984962-.1122682-1.366.366z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m1 32c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h2c.55228475 0 1-.4477153 1-1s-.44771525-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m4.716 45.866 1.731-1c.31195078-.1773616.50495322-.5082732.5057421-.8671183.00078889-.3588451-.19075673-.6906021-.50192468-.8693336-.31116795-.1787314-.694247-.1770325-1.00381742.0044519l-1.731 1c-.31195078.1773616-.50495322.5082732-.5057421.8671183-.00078889.3588451.19075673.6906021.50192468.8693336.31116795.1787314.694247.1770325 1.00381742-.0044519z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13.134 51.553-1 1.731c-.1814844.3095704-.1831833.6926495-.0044519 1.0038174.1787315.311168.5104885.5027136.8693336.5019247s.6897567-.1937913.8671183-.5057421l1-1.731c.2716903-.47786.1067416-1.0854205-.3693057-1.3602745-.4760473-.2748541-1.0846885-.1139391-1.3626943.3602745z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/darkIcon.50240fee.svg";
export { ForwardRef as ReactComponent };